import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import KeyBenefits from "../Components/KeyBenefits";
import HeroSection from "../Components/HeroSection";
import HowItWorks from "../Components/HowItWorks";
import FeaturedServices from "../Components/FeaturedServices";
import Testimonials from "../Components/Testimonials";
import WhyChooseUs from "../Components/WhyChooseUs";
import CallToAction from "../Components/CallToAction";
import Footer from "../Components/Footer";
import AnimatedBackground from "../Components/AnimatedBackground";

const Landing = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/home");
    }
  }, []);

  return (
    <div className="app">
      <AnimatedBackground>
        <Navbar />
        <div className="welcome-section" style={{ 
          width: '100%', 
          textAlign: 'center', 
          margin: '160px 0 60px 0', 
          padding: '120px 0', 
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="landing-headline" style={{ 
            fontSize: 'clamp(3rem, 6vw, 4rem)', 
            fontWeight: 'normal', 
            color: '#ffffff', 
            marginTop: '8px', 
            letterSpacing: '0.5px', 
            fontFamily: '"Handel Gothic Std Regular", sans-serif'
          }}>
            Welcome to the Marketplace for Real Skills
          </div>
          <div className="landing-subheadline" style={{ 
            fontSize: '1.3rem', 
            fontWeight: '400', 
            color: '#cccccc', 
            marginTop: '30px', 
            marginBottom: '30px', 
            fontFamily: '"Open Sans", "Open Sans", sans-serif'
          }}>
            Find people to learn from. Be someone others can learn from.
          </div>
        </div>
        <HeroSection />
      </AnimatedBackground>
      <KeyBenefits />
      <HowItWorks />
      <FeaturedServices />
      <Testimonials />
      <WhyChooseUs />
      <CallToAction />
      <Footer />
    </div>
  );
};

export default Landing;
